export default __webpack_public_path__ + "img/ClintonPerksLogo-01.png";